export class Region {
  constructor() {
    this.id = "";
    this.name = "";
    this.createdBy = "";
  }
}
